import { formatDate } from "@utils/date.util";
import { END_POINT } from "@constants/api.constants";
import { PRIMARY_KEY } from "@constants/app.constants";
import { formatStatus } from "@utils/string.utils";

const keyColumn = PRIMARY_KEY;
const { USER_STATUS_TOGGLE } = END_POINT;


const tableTitle = "Inventory Category List";
// const keyColumn = "id";
const menuUrl = "inventory/category";
const tableColumn = [
  {
    id: "image",
    numeric: false,
    disablePadding: false,
    label: "Image",
    type: "FILE_UPLOAD",
    formatData: (data) => {
      return (
        <img
          src={data}
          alt=" Image"
          style={{ width: "100px", height: "50px" }}
        />
      );
    },
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
        isBadge: true,
        badgeClick: USER_STATUS_TOGGLE,
        primaryKey: keyColumn,
        formatData: formatStatus,
        badgeText: {
          1: "Enable",
          2: "Disable",
        },
        badgeColor: {
          1: "success",
          2: "danger",
        },
      },
  {
      id: "created_at",
      numeric: false,
      disablePadding: false,
      label: "Created At",
      formatData: formatDate,
      sort: true,
    },
];
const breadCrumbs = [{ name: "Inventory Category", menu_url: "/inventory/category" }];

const filters = [
  {
    name: "name",
    id: "name",
    label: "Name",
    value: "",
    type: "TEXT",
    validations: [],
    isVertical: true,
    groupClass: "col-md-3",
  },
];
// const additionalActions = ({ handleViewDetail }) => [
//   {
//     name: "View Details",
//     icon: "eye",
//     buttonClass: "btn btn-outline-info btn-sm",
//     onClick: handleViewDetail,
//   },
// ];
export {
  tableTitle,
  keyColumn,
  tableColumn,
  breadCrumbs,
  menuUrl,
  filters,
  // additionalActions,
};
